export const SectionHeading = ({ title, dark = false, id }) => (
  <h2
    className={`cd-reveal font-display text-3xl font-semibold leading-[1.1] tracking-[-0.025em] sm:text-4xl lg:text-[44px] ${dark ? "text-[#f5f5ee]" : "text-[#292929]"}`}
    data-testid={id ? `${id}-title` : undefined}
  >
    {title}
  </h2>
);
